import styled from 'styled-components';

export const Container = styled.div`
  min-height: 100vh;
  width: 100%;
  background: var(--white-dark);
  display: flex;
  flex-direction: column;

  @media (max-width: 800px) {
    padding: 0;
  }
`;

export const Content = styled.div`
  height: 100%;
  width: 100%;
  padding: 40px 30%;

  @media (max-width: 800px) {
    padding: 32px 24px;
  }
`;

export const ListItem = styled.button`
  width: 100%;
  background: var(--white-darker);
  padding: 20px 30px;
  margin-top: 20px;
  border-radius: 8px;
  height: 60px;
  color: var(--black-3);
  border: 0;
  font-weight: bold;
  font-size: 18px;
  cursor: pointer;
  outline: none;
  display: flex;
  justify-content: space-between;
  align-items: center;

  > div {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`;
